<style>
.list__tile {
  font-size: 14px;
}
</style>

<template>
  <v-row dense>
    <v-col cols="12">
      <div class="font-weight-bold">{{ $t('Doručení objednávky') }}</div>
    </v-col>
    <v-col class="text-left" cols="6">
      <div :class="{ caption: true, 'grey--text': validEmail, 'red--text': !validEmail }">{{
          $t('Elektronická adresa')
        }}
      </div>
    </v-col>
    <v-col class="text-right" cols="6">
      <div class="grey--text">{{ cachedEmail }}</div>
      <v-dialog v-model="dialogEmail" persistent max-width="480px">
        <template v-slot:activator="{ on }">
          <a color="primary" text v-on="on">{{ $t('modifyEmail') }}</a>
        </template>
        <v-card>
          <v-toolbar fixed flat height="60px">
            <v-spacer></v-spacer>
            <v-toolbar-title class="justify-center headline primary--text">
              {{ $t('Doručovací email') }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn id="revert-button" icon @click="revertEmail" v-on="on">
                  <v-icon>close</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('Zrušení změn') }}</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text class="background: secondary">
            <v-col>
              <v-form ref="emailForm" v-model="validEmail">
                <setting-email v-model="cachedEmail" required></setting-email>
                <small>*{{ $t('povinné položky') }}</small>
              </v-form>
            </v-col>
            <v-col mt-3 v-if="isRegistered">
              <v-checkbox v-model="basket.saveAddress" :label="$t('Trvale uložit změny')"
                          :disabled="!validEmail || !changedEmail"></v-checkbox>
            </v-col>
            <v-col class="text-center">
              <v-btn color="primary" @click="saveEmail"
                     :disabled="!validEmail || !changedEmail">{{ $t('Upravit') }}
              </v-btn>
            </v-col>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-col>
    <v-col class="text-left" cols="6">
      <div :class="{ caption: true, 'grey--text': validPhone, 'red--text': !validPhone }">{{ $t('Telefon') }}</div>
    </v-col>
    <v-col class="text-right" cols="6">
      <div class="grey--text">{{ cachedPhone }}</div>
      <v-dialog v-model="dialogPhone" persistent max-width="480px">
        <template v-slot:activator="{ on }">
          <a color="primary" text v-on="on">{{ $t('modifyPhone') }}</a>
        </template>
        <v-card>
          <v-toolbar fixed flat height="60px">
            <v-spacer></v-spacer>
            <v-toolbar-title class="justify-center headline primary--text">
              {{ $t('Telefon') }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn id="revert-button" icon @click="revertPhone" v-on="on">
                  <v-icon>close</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('Zrušení změn') }}</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text class="background: secondary">
            <v-col mt-3>
              <v-form ref="phoneForm" v-model="validPhone">
                <v-col mt-3>
                  <setting-phone v-model="cachedPhone" required></setting-phone>
                </v-col>
                <small>*{{ $t('povinné položky') }}</small>
              </v-form>
            </v-col>
            <v-col mt-3 v-if="isRegistered">
              <v-checkbox v-model="basket.saveAddress" :label="$t('Trvale uložit změny')"
                          :disabled="!validPhone || !changedPhone"></v-checkbox>
            </v-col>
            <v-col class="text-center">
              <v-btn color="primary" @click="savePhone"
                     :disabled="!validPhone || !changedPhone">{{ $t('Upravit') }}
              </v-btn>
            </v-col>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-col>
    <v-col class="text-left" cols="6" v-if="!allCredit">
      <div :class="{ caption: true, 'grey--text': validInvoice, 'red--text': !validInvoice }">{{
          $t('Fakturační adresa')
        }}
      </div>
    </v-col>
    <v-col class="text-right grey--text" cols="6" v-if="!allCredit">
      <display-address :value="cachedInvoice"></display-address>
      <v-dialog v-model="dialogInvoice" persistent max-width="480px">
        <template v-slot:activator="{ on }">
          <a color="primary" text v-on="on">{{ $t('modifyAddress') }}</a>
        </template>
        <v-card>
          <v-toolbar fixed flat height="60px">
            <v-spacer></v-spacer>
            <v-toolbar-title class="justify-center headline primary--text">
              {{ $t('Fakturační adresa') }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn id="revert-button" icon @click="revertInvoice" v-on="on">
                  <v-icon>close</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('Zrušení změn') }}</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text class="background: secondary">
            <v-row>
              <v-col cols="12">
                <v-form ref="invoiceForm" v-model="validInvoice">
                  <v-col mt-3>
                    <setting-address v-model="cachedInvoice" required></setting-address>
                  </v-col>
                </v-form>
                <small>*{{ $t('povinné položky') }}</small>
              </v-col>
              <v-col mt-3 v-if="isRegistered">
                <v-checkbox v-model="basket.saveAddress" :label="$t('Trvale uložit změny')"
                            :disabled="!validInvoice || !changedInvoice"></v-checkbox>
              </v-col>
            </v-row>
            <v-col class="text-center">
              <v-btn color="primary" @click="saveInvoice"
                     :disabled="!validInvoice || !changedInvoice">{{ $t('Upravit') }}
              </v-btn>
            </v-col>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-col>
    <v-col class="text-left" cols="6"
           v-if="!allCredit">
      <!--    <v-col class="text-left" cols="6" v-show="customer.customerName || customer.idKey || customer.countryId" v-if="!allCredit">-->
      <div :class="{ caption: true, 'grey--text': validCompany, 'red--text': !validCompany }">{{
          $t('Fakturační údaje')
        }}
      </div>
    </v-col>
    <v-col class="text-right grey--text" cols="6" v-if="!allCredit">
      <!--    <v-col class="text-right grey&#45;&#45;text" cols="6" v-show="customer.customerName || customer.idKey || customer.countryId" v-if="!allCredit">-->
      <display-company :value="cachedCompany"></display-company>
      <v-dialog v-model="dialogCompany" persistent max-width="480px" v-if="!allCredit">
        <template v-slot:activator="{ on }">
          <a color="primary" text v-on="on">{{ $t('Upravit údaje') }}</a>
        </template>
        <v-card>
          <v-toolbar fixed flat height="60px">
            <v-spacer></v-spacer>
            <v-toolbar-title class="justify-center headline primary--text">
              {{ $t('Fakturační údaje') }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn id="revert-button" icon @click="revertCompany" v-on="on">
                  <v-icon>close</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('Zrušení změn') }}</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text class="background: secondary">
            <v-col cols="12" mb-3>
              <v-form ref="form" v-model="validCompany">
                <setting-company v-model="cachedCompany" required></setting-company>
              </v-form>
              <small>*{{ $t('povinné položky') }}</small>
            </v-col>
            <!--            <v-col mt-3 v-if="isRegistered">-->
            <!--              <v-checkbox v-model="basket.saveAddress" :label="$t('Trvale uložit změny')" :disabled="!validCompany || !changedCompany"></v-checkbox>-->
            <!--            </v-col>-->
            <v-col class="text-center">
              <v-btn color="primary" @click="saveCompany"
                     :disabled="!validCompany || !changedCompany">{{ $t('Upravit') }}
              </v-btn>
            </v-col>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-col>
    <v-col class="text-left" cols="6" v-show="deliveryTypes.length > 0">
      <div
          :class="{ caption: true, 'grey--text': validDelivery, 'red--text': basket.shippingAddress ? !validDelivery : !validInvoice }">
        {{ $t('Doručovací adresa') }}
      </div>
    </v-col>
    <v-col class="grey--text text-right" cols="6" v-show="deliveryTypes.length > 0">
      <div v-if="basket.shippingAddress">
        <display-address :value="cachedDelivery"></display-address>
      </div>
      <div v-else class="grey--text">{{ $t('Stejná jako fakturační') }}</div>
      <v-dialog v-model="dialogDelivery" persistent max-width="480px">
        <template v-slot:activator="{ on }">
          <a color="primary" text v-on="on">{{ $t('modifyAddress') }}</a>
        </template>
        <v-card>
          <v-toolbar fixed flat height="60px">
            <v-spacer></v-spacer>
            <v-toolbar-title class="justify-center headline primary--text">
              {{ $t('Doručovací adresa') }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn id="revert-button" icon @click="revertDelivery" v-on="on">
                  <v-icon>close</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('Zrušení změn') }}</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text class="background: secondary">
            <v-col cols="12">
              <v-form ref="deliveryForm" v-model="validDelivery">
                <setting-address v-model="cachedDelivery" required></setting-address>
              </v-form>
              <small>*{{ $t('povinné položky') }}</small>
            </v-col>
            <v-col mt-3 v-if="isRegistered">
              <v-checkbox v-model="basket.saveAddress" :label="$t('Trvale uložit změny')"></v-checkbox>
            </v-col>
            <v-col class="text-center">
              <v-btn color="primary" @click="saveDelivery"
                     :disabled="!validDelivery || !changedDelivery">{{ $t('Upravit') }}
              </v-btn>
            </v-col>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-col>
    <v-col class="text-right" xs="10" offset-xs2 v-show="deliveryTypes.length > 0">
      <v-select solo flat :max-heigh="100" :hint="$t('Způsob doručení')" persistent-hint :items="deliveryTypes"
                v-model="deliveryType" single-linemenu-props="bottom" required @change="deliveryTypeChange">
        <template slot="selection" slot-scope="data">
          <v-col class="text-left">{{ data.item.typeDesc }}</v-col>
          <v-col class="text-right">{{ data.item.price | currency }}</v-col>
        </template>
        <template slot="item" slot-scope="data">
          <v-list-item-content>
            <v-list-item-title>
              <v-col class="text-left">{{ data.item.typeDesc }}</v-col>
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item>
            <v-col class="text-right">{{ data.item.price | currency }}</v-col>
          </v-list-item>
        </template>
      </v-select>
    </v-col>
  </v-row>
</template>

<script>
import BasketMixin from '@/mixins/basket-mixin.js'
import CustomerMixin from '@/mixins/customer-mixin.js'
import StorageMixin from '@/mixins/storage-mixin.js'
import TransformMixin from '@gravela/vue-component-library/src/mixins/transform-mixin.js'
import SettingAddress from '@gravela/vue-component-library/src/components/setting-address.vue'
import SettingCompany from '@gravela/vue-component-library/src/components/setting-company.vue'
import DisplayAddress from '@/components/display-address.vue'
import DisplayCompany from '@/components/display-company.vue'
import SettingEmail from '@gravela/vue-component-library/src/components/setting-email.vue'
import SettingPhone from '@gravela/vue-component-library/src/components/setting-phone.vue'

const $ = require('jquery')
const _ = require('lodash')

export default {
  mixins: [BasketMixin, CustomerMixin, StorageMixin, TransformMixin],
  components: {
    'setting-email': SettingEmail,
    'setting-phone': SettingPhone,
    'setting-address': SettingAddress,
    'setting-company': SettingCompany,
    'display-address': DisplayAddress,
    'display-company': DisplayCompany
  },
  data() {
    return {
      validEmail: true,
      validPhone: true,
      validDelivery: true,
      validInvoice: true,
      validCompany: true,
      deliveryType: null,
      dialogEmail: false,
      dialogPhone: false,
      dialogDelivery: false,
      dialogInvoice: false,
      dialogCompany: false,
      cachedEmail: null,
      cachedPhone: null,
      cachedCompany: {},
      cachedDelivery: {},
      cachedInvoice: {},
    }
  },
  created() {
    this.deliveryType = !!this.basket.availableDeliveryTypes && this.basket.availableDeliveryTypes.length > 0 ? this.basket.availableDeliveryTypes[0] : null
    this.deliveryTypeChange(this.deliveryType)
    this.revertEmail()
    this.revertPhone()
    this.revertCompany()
    this.revertInvoice()
    this.revertDelivery()
    this.saveEmail()
    this.savePhone()
    this.saveCompany()
    this.saveInvoice()
    this.saveDelivery()
  },
  // mounted() {
  //   if (!this.isRegistered) {
  //     this.cachedEmail = this.$oauth2.storage.hasValue('chip-ano-email') ? this.$oauth2.storage.getValue('chip-ano-email') : null
  //     this.cachedDelivery = this.$oauth2.storage.hasValue('chip-ano-deliv') ? JSON.parse(JSON.stringify(this.$oauth2.storage.getValue('chip-ano-deliv'))) : {}
  //     this.cachedInvoice = this.$oauth2.storage.hasValue('chip-ano-invo') ? JSON.parse(JSON.stringify(this.$oauth2.storage.getValue('chip-ano-invo'))) : {}
  //   }
  // },
  computed: {
    paymentCompany() {
      return this.basket.company ? this.basket.company : this.customer
      // return !!this.basket.company ? this.basket.company : {
      //   customerName: this.customer.customerName,
      //   idKey: this.customer.idKey,
      //   countryId: this.customer.countryId
      // }
    },
    paymentEmail() {
      return this.basket.email ? this.basket.email : this.customerEmail
    },
    paymentPhone() {
      return this.basket.phone ? this.basket.phone : this.customerPhone
    },
    paymentDelivery() {
      return !$.isEmptyObject(this.basket.shippingAddress) ? this.basket.shippingAddress : this.customerDelivery
    },
    paymentInvoice() {
      return !$.isEmptyObject(this.basket.billingAddress) ? this.basket.billingAddress : this.customerInvoice
    },
    customerEmail() {
      return this.customer.workingEMail || this.customer.eMail
    },
    customerPhone() {
      return this.customer.workingPhoneNo || this.customer.phoneNo
    },
    customerDelivery() {
      return this.hasDelivery ? this.contactAddress : this.invoiceAddress
    },
    customerInvoice() {
      return this.hasInvoice ? this.invoiceAddress : this.contactAddress
    },
    changedEmail() {
      return !_.isEqual(this.paymentEmail, this.cachedEmail)
    },
    changedPhone() {
      return !_.isEqual(this.paymentPhone, this.cachedPhone)
    },
    changedCompany() {
      return !_.isEqual(this.paymentCompany, this.cachedCompany)
    },
    changedDelivery() {
      return !_.isEqual(this.paymentDelivery, this.cachedDelivery)
    },
    changedInvoice() {
      return !_.isEqual(this.paymentInvoice, this.cachedInvoice)
    },
    hasInvoice: {
      get() {
        return !!this.customer.invoiceAddress && !$.isEmptyObject(this.customer.invoiceAddress)
      }
    },
    hasDelivery: {
      get() {
        return !!this.customer.contactAddress && !$.isEmptyObject(this.customer.contactAddress)
      }
    },
    hasCompanyName: {
      get() {
        return !!this.customer.companyName && !$.isEmptyObject(this.customer.companyName)
      }
    },
    hasIdKey: {
      get() {
        return !!this.customer.idKey && !$.isEmptyObject(this.customer.idKey)
      }
    },
    hasCountryId: {
      get() {
        return !!this.customer.countryId && !$.isEmptyObject(this.customer.countryId)
      }
    }
  },
  methods: {
    saveEmail() {
      this.dialogEmail = false
      this.basket.email = this.cachedEmail
      if (!this.isRegistered) {
        this.$oauth2.storage.setValue('chip-ano-email', this.basket.email, this.institutionId, this.customerId)
      }
      if (this.basket.saveAddress) {
        this.customer.workingEMail = this.cachedEmail
      }
    },
    revertEmail() {
      this.dialogEmail = false
      if (!this.isRegistered) {
        if (!this.basket.email) {
          this.basket.email = this.$oauth2.storage.getValue('chip-ano-email', this.institutionId, this.customerId)
        }
        this.cachedEmail = this.basket.email
      } else {
        this.cachedEmail = this.customerEmail
      }
      this.validEmail = !!this.cachedEmail
    },
    savePhone() {
      this.dialogPhone = false
      this.basket.phone = this.cachedPhone
      if (!this.isRegistered) {
        this.$oauth2.storage.setValue('chip-ano-phone', this.basket.phone, this.institutionId, this.customerId)
      }
      if (this.basket.saveAddress) {
        this.customer.workingPhoneNo = this.cachedPhone
      }
    },
    revertPhone() {
      this.dialogPhone = false
      if (!this.isRegistered) {
        if (!this.basket.phone) {
          this.basket.phone = this.$oauth2.storage.getValue('chip-ano-phone', this.institutionId, this.customerId)
        }
        this.cachedPhone = this.basket.phone
      } else {
        this.cachedPhone = this.customerPhone
      }
      this.validPhone = !!this.cachedPhone
    },
    saveCompany() {
      // this.basket.company = this.cachedCompany
      // if (this.basket.saveAddress) {
      //   this.customer.invoiceAddress = this.cachedCompany
      // }
      this.dialogCompany = false
      this.basket.taxId = this.cachedCompany.countryId
      this.basket.companyId = this.cachedCompany.idKey

    },
    revertCompany() {
      this.dialogCompany = false
      this.cachedCompany = {
        // customerName: this.paymentCompany.customerName,
        idKey: this.paymentCompany.idKey,
        countryId: this.paymentCompany.countryId
      }
      this.basket.company = null
    },
    saveDelivery() {
      this.dialogDelivery = false
      this.basket.shippingAddress = JSON.parse(JSON.stringify(this.cachedDelivery))
      if (!this.isRegistered) {
        this.$oauth2.storage.setValue('chip-ano-deliv', this.basket.shippingAddress, this.institutionId, this.customerId)
      }
      if (this.basket.saveAddress) {
        this.customer.contactAddress = this.cachedDelivery
      }
    },
    revertDelivery() {
      this.dialogDelivery = false
      if (!this.isRegistered) {
        if ($.isEmptyObject(this.basket.shippingAddress)) {
          this.basket.shippingAddress = this.$oauth2.storage.hasValue('chip-ano-deliv', this.institutionId, this.customerId) ? JSON.parse(JSON.stringify(this.$oauth2.storage.getValue('chip-ano-deliv', this.institutionId, this.customerId))) : {}
        }
        this.cachedDelivery = JSON.parse(JSON.stringify(this.basket.shippingAddress))
      } else {
        this.cachedDelivery = JSON.parse(JSON.stringify(this.customerDelivery))
      }
      this.validDelivery = !$.isEmptyObject(this.cachedDelivery)
    },
    deliveryTypeChange(value) {
      this.basket.selectedDeliveryType = value ? value.typeId : null
    },
    saveInvoice() {
      this.dialogInvoice = false
      this.basket.billingAddress = JSON.parse(JSON.stringify(this.cachedInvoice))
      if (!this.isRegistered) {
        this.$oauth2.storage.setValue('chip-ano-invo', this.basket.billingAddress, this.institutionId, this.customerId)
      }
      if (this.basket.saveAddress) {
        this.customer.invoiceAddress = this.cachedInvoice
      }
    },
    revertInvoice() {
      this.dialogInvoice = false
      if (!this.isRegistered) {
        if ($.isEmptyObject(this.basket.billingAddress)) {
          this.basket.billingAddress = this.$oauth2.storage.hasValue('chip-ano-invo', this.institutionId, this.customerId)
              ? JSON.parse(JSON.stringify(this.$oauth2.storage.getValue('chip-ano-invo', this.institutionId, this.customerId)))
              : {}
        }
        this.cachedInvoice = JSON.parse(JSON.stringify(this.basket.billingAddress))
      } else {
        this.cachedInvoice = JSON.parse(JSON.stringify(this.customerInvoice))
      }
      this.validInvoice = !$.isEmptyObject(this.cachedInvoice)
    },
    valid() {
      this.$emit('valid',
          this.validEmail
          && this.validPhone
          && (this.deliveryTypes.length === 0 || this.basket.billingAddress !== null
              ? (this.allCredit ? this.validEmail && this.validPhone : this.validInvoice)
              : this.validDelivery))
    }
  },
  watch: {
    validEmail() {
      this.valid()
    },
    validDelivery() {
      this.valid()
    },
    validInvoice() {
      this.valid()
    },
    customerEmail: {
      handler() {
        this.revertEmail()
      },
      deep: true
    },
    customerDelivery: {
      handler() {
        this.revertDelivery()
      },
      deep: true
    },
    customerInvoice: {
      handler() {
        this.revertInvoice()
      },
      deep: true
    }
  }
}
</script>
